import ProxyUrls from '@/constants/ProxyUrls';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    email: '',
    firstName: '',
    showSessionExp: false,
    isSessionActive: false,
    emailConfirmed: false,
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async registerUser({ state }, payload) {
      if (!payload) return null;

      try {
        const { data } = await Vue.prototype.$axios({
          method: 'post',
          url: ProxyUrls.registerUrl,
          data: payload,
        });

        if (data && data.httpStatus === 200) {
          // commit('setEmail', data.responseData.email);
          // commit('setName', data.responseData.name);
          // commit('setSessionActive', true);
          return true;
        }
        return false;
      } catch (err) {
        throw new Error(err);
      }
    },

    async login({ commit }, payload) {
      if (!payload) return null;

      try {
        const { data } = await Vue.prototype.$axios({
          method: 'post',
          url: ProxyUrls.loginUrl,
          data: payload,
        });

        if (data) {
          commit('setEmail', data.email);
          commit('setFirstName', data.firstName);
          commit('setSessionActive', true);
          commit('setEmailConfirmed', data.emailConfirmed === 'true' || data.emailConfirmed === true);
        }
        return data;
      } catch (err) {
        throw new Error(err);
      }
    },

    async logout({ commit }) {
      try {
        const { data } = await Vue.prototype.$axios({
          method: 'get',
          url: ProxyUrls.logoutUrl,
        });

        if (data) {
          commit('logoutUser');
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    // This executes the very initial petition to API, return raw error cuz axios manage related errors a bit different
    async getCsrfTokenAndStatus({commit}) {
      try {
        const response = await Vue.prototype.$axios({
          method: 'get',
          url: ProxyUrls.getCsrfTokenAndStatus,
        });

        // Set csrf token in headers
        Vue.prototype.$axios.defaults.headers.common["x-csrf-token"] = response.data.csrfToken;

        // Set site status in backend store
        commit('backendStore/setSiteEnabled', response.data.siteEnabled, { root: true });
      } catch (error) {
        throw error;
      }
    },

    async initiateAppSession({ commit, state }) {
      try {
        const res = await Vue.prototype.$axios({
          method: 'get',
          url: ProxyUrls.isSessionActive,
        });
  
        if (res && res.data === true) { // If session is valid for server
          commit('setEmail', localStorage.getItem('email'));
          commit('setFirstName', localStorage.getItem('firstName'));
          commit('setSessionActive', true);
          commit(
            'setEmailConfirmed',
            localStorage.getItem('emailConfirmed') === 'true'
            || localStorage.getItem('emailConfirmed') === true,
          );
        }
        else {
          commit('setSessionActive', false);
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    async checkSessionValidity() {
      try {
        const res = await Vue.prototype.$axios({
          method: 'get',
          url: ProxyUrls.isSessionActive,
        });
        if (res && res.data === true) return true;
        
        return false;
      } catch (error) {
        throw new Error(err);
      }
    }
  },
  mutations: {
    setEmailConfirmed(state, val) {
      state.emailConfirmed = val;
      localStorage.setItem('emailConfirmed', val);
    },
    setEmail(state, email) {
      state.email = email;
      localStorage.setItem('email', email);
    },

    setFirstName(state, firstName) {
      state.firstName = firstName;
      localStorage.setItem('firstName', firstName);
    },

    setSessionActive(state, val) {
      state.isSessionActive = val;
      if (!val) {
        localStorage.removeItem('email');
        localStorage.removeItem('firstName');
        localStorage.removeItem('emailConfirmed');
        localStorage.removeItem('sessionDT');
      }
    },

    setShowSessionExp(state, val) {
      state.showSessionExp = val;
    },

    logoutUser(state) {
      state.firstName = '';
      state.email = '';
      localStorage.removeItem('email');
      localStorage.removeItem('firstName');
      localStorage.removeItem('emailConfirmed');
      state.isSessionActive = false;
    },
  },
  getters: {
    getEmail(state) {
      return state.email;
    },

    getFirstName(state) {
      if (!state.firstName) return '';
      return state.firstName;
    },

    isSessionActive(state) {
      return state.isSessionActive;
    },

    showSessionExp(state) {
      return state.showSessionExp;
    },

    emailConfirmed(state) {
      return state.emailConfirmed;
    },
  },
};
